import checkLuhnAlgorithm from 'common/util/checkLuhnAlgorithm';

const allNumbersRegex = /^\d+$/;

export default function isCardNumber(cardNumber) {
  return (
    typeof cardNumber === 'string' &&
    allNumbersRegex.test(cardNumber) &&
    checkLuhnAlgorithm(cardNumber) &&
    (/^(34|37)\d{13}$/.test(cardNumber) || // American Express: Starting with 34 or 37, length 15 digits.
      /^4\d{12}(\d{3})?$/.test(cardNumber) || // Visa: Starting with 4, length 13 or 16 digits.
      /^5[1-5]\d{14}$/.test(cardNumber) || // MasterCard: Starting with 51 through 55, length 16 digits.
      /^6(?:011|5\d{2})\d{12}$/.test(cardNumber) || // Discover: Starting with 6011, length 16 digits or starting with 5, length 15 digits.
      /^3(?:0[0-5]|[68]\d)\d{11}$/.test(cardNumber)) // Diners Club: Starting with 300 through 305, 36, or 38, length 14 digits.
  );
}
